<template>
  <div class="my-little-shop">
    <div class="shop-top">
      <div class="top-header-img">
        <div class="header-img">
          <img :src="headerImg" alt />
        </div>
        <div class="header-info">
          <div class="info-name">{{cardData.realName || cardData.nickName}} </div>
          <div class="info-phone">{{cardData.phone}}</div>
          <div class="vip-img">
            <img :src="vipImg" alt />
          </div>
        </div>
      </div>
      <div class="top-syn">
        <div class="syn-div">
          <div class="syn-lab">职位：</div>
          <div class="syn-val">{{cardData.jobName}}</div>
          <img @click.prevent="goCard()" src="./img/card.png" alt="">
        </div>
        <div class="syn-div">
          <div class="syn-lab">公司：</div>
          <div class="syn-val">{{cardData.city}}</div>
        </div>
        <div class="syn-div">
          <div class="syn-lab">签名：</div>
          <div class="syn-val">{{cardData.motto}}</div>
        </div>
        <div class="syn-div">
          <div class="syn-lab">简介：</div>
          <div class="syn-val">{{cardData.profiles}}</div>
        </div>
      </div>
      <div class="top-search">
        <van-field v-model="value" @input="onsearch" placeholder="搜索产品/文章" />
        <div class="search-but" @click="onsearch"></div>
      </div>
      <div class="top-right" @click="onVisitor">
        <div class="right-img">
          <img src="./img/visitor.png" alt />
        </div>
        <div>
          <div>今日访客：{{visitorData.todayVisitorCount || 0}}</div>
          <div>访客总量：{{visitorData.totalVisitorCount || 0}}</div>
        </div>
      </div>
    </div>
    <div class="shop-center">
      <div class="myhome-info-bottom">
        <ul class="info-list-top">
          <li
            :class="isLinkTop==item.type?'list-style list-check-style':'list-style'"
            v-for="(item,index) in liListTop"
            :key="index"
            @click="checkTopLi(item)"
          >{{item.name}}</li>
        </ul>
        <div class="info-list-bottom" v-if="isLinkTop=='product'">
          <div>
            <ul class="info-dataList">
              <li
                v-for="(item,index) in productList"
                :key="index"
                :class="isLinkBot==index ? 'li-style2 li-check-style2' : 'li-style2'"
                @click="chooseLi2(item,index)"
              >
                {{item.name}}
                ( {{item.value.length}} )
              </li>
            </ul>
            <div class="info-list-list" v-for="(item,index) in productList" :key="index">
              <div v-if="item.name=='保险' && leave==item.name">
                <div class="bank-list" v-for="(ctem, index) in item.value" :key="index">
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-left-img">
                        <img :src="ctem.thumbnail" alt />
                      </div>
                      <div>
                        <p class="product-list-title">{{ctem.name}}</p>
                        <p class="product-list-summary">手续简单抵押率高</p>
                      </div>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="ctem.digest"></p>
                  </div>
                </div>
              </div>
              <div v-if="item.name!='保险' && leave==item.name">
                <div
                  class="bank-list product-safe"
                  v-for="(ctem, index) in item.value"
                  :key="index"
                >
                  <div class="product-safe-left">
                    <img :src="ctem.thumbnail" alt />
                  </div>
                  <div class="product-safe-right">
                    <div>
                      <p class="product-list-title">{{ctem.name}}</p>
                      <div class="safe-right-height">
                        <p v-html="ctem.digest" class="product-list-summary"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isLinkTop=='article'">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :offset="1"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div class="home-data-list" v-for="(item,index) in dataList1 " :key="'home1'+index">
                <div class="home-list-sty" @click.prevent="goToDetails(item.artcId,item.coverLink)">
                  <div class="list-left">
                    <img :src="item.coverLink" alt />
                  </div>
                  <div class="list-right">
                    <div class="list-r-tit">
                      <svg-icon icon-class="home_name2"></svg-icon>
                      <span>{{item.title}}</span>
                    </div>
                    <div class="list-r-foot">
                      <span>阅读{{ item.viewCount }}次</span>
                      <span>转发{{ item.fwdCount }}次</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="hint-div" v-if="isShow">没有更多了~~~</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import URL from '@/api/api'
import URLTB from '@/api/apiTB'
export default {
  data() {
    return {
      headerImg: require(`../../assets/img/user.png`),
      vipImg: require('../../assets/img/member.png'),
      value: '',
      leave:'',
      isLinkTop: 'product',
      cardData:{},
      visitorData:{},
      liListTop: [
        {
          name: '推荐产品',
          type: 'product'
        },
        {
          name: '分享文章',
          type: 'article'
        },
      ],
      productList: [],
      isLinkBot: '0',
      dataList1: [],
      loading: false,
      finished: false,
      refreshing: false,
      rowNum: 5,
      nowPage: 0,
      isShow:false,//是否搜索到数据
    }
  },
  mounted() {
    this.fatchdata()
    this.getData()
    this.getVisitor()
  },
  methods: {
    getVisitor(){//访客足迹数据
      let data = {
        cusType: 'all',
        agentUserId: localStorage.getItem('userid'),
        searchStr: '',
        page: 1,
        size: 10
      }
      this.$fetchPost(URLTB.getClients.url,data).then(res=>{
        this.visitorData=res.data.data
      })
    },
    goCard(){//查看名片
      let userId=localStorage.getItem('userid')
      this.$router.push({path:'/businessCard',query:{userId:userId}})
    },
    getData(){//我的小店信息
      let data={
        userId:localStorage.getItem('userid')
      }
      this.$fetchGet(URLTB.getLittleShop.url,data).then(res=>{
        if(res.data.code==20000){
          this.cardData=res.data.data
        }
      })
    },
    onVisitor(){//我的访客
        this.$router.push('/myVisitor')
    },
    onsearch() {
      if(this.isLinkTop=='product'){
        this.productList=[]
        this.fatchdata()
      }else if(this.isLinkTop=='article'){
        this.dataList1=[]
        this.getArticles()
      }
    },
    checkTopLi(value) {
      this.isLinkTop = value.type
      this.dataList1 = []
      this.nowPage = 0
      if(value.name=='推荐产品'){
        this.dataList1=[]
        this.fatchdata()
      }
    },
    chooseLi2(item, i) {
      this.isLinkBot = i
      this.leave = item.name
    },
    fatchdata() {//推荐产品
      this.$fetchPost(URL.recommendProduct.url, { phoneNo: localStorage.getItem('phone') ,searchStr:this.value}).then(res => {
        this.productList = res.data.data;
        if(res.data.data.length>0){
          this.leave = res.data.data[0].name
        }
        if(this.productList.length<=0){
          this.isShow=true
        }
      })
    },
    getArticles() {//分享文章
      let unionid = localStorage.getItem('unionid')
      let data = {
        unionid: unionid,
        row_num: this.rowNum,
        now_page: this.nowPage,
        artcType: 'ARTUPLD',
        searchStr:this.value
      }
      this.$fetchPost(URL.articlesShared.url, data).then(res => {
        this.dataList1 = this.dataList1.concat(res.data.data.list)
        this.loading = false
        if (res.data.data.total <= this.dataList1.length) {
          this.finished = true
          this.refreshing = false
        }
      })
    },
    onLoad() {
      this.nowPage++
      this.loading = true
      this.finished = false
      this.refreshing = false
      this.getArticles()
    },
    onRefresh() {
      this.nowPage = 0
      this.dataList1 = []
      this.onLoad()
    },
  }
}
</script>

<style lang="less" scoped>
.my-little-shop {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  .shop-top {
    width: 375px;
    height: 256px;
    background: url("./img/bg.png") no-repeat 100%;
    background-size: 100% 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .top-header-img {
      display: flex;
      .header-img {
        width: 60px;
        height: 60px;
      }
      .header-info {
        color: #333333;
        .info-name {
          margin: 5px 0 2px 0;
          font-weight: 500;
          font-size: 14px;
        }
        .info-phone {
          font-weight: 400;
          font-size: 11px;
        }
        .vip-img {
          width: 62px;
          height: 15px;
          position: relative;
          top: 3px;
          img {
            position: absolute;
          }
        }
      }
    }
    .top-syn {
      margin: 5px 0 0 25px;
      color: #333333;
      font-size: 9px;
      .syn-div {
        display: flex;
        margin-top: 10px;
        img{
          width: 44px;
          margin-left: 15px;
        }
        .syn-lab {
          font-weight: 500;
        }
        .syn-val {
          max-width: 297px;
          font-weight: 400;
        }
      }
    }
    .top-search {
      width: 355px;
      height: 30px;
      margin: 10px auto auto;
      display: flex;
      justify-content: space-between;
      background: url("./img/search.png") no-repeat 100%;
      background-size: 100% 100%;
      .van-cell {
        width: 310px;
        height: 30px;
        line-height: 30px;
        padding: 0 0 0 15px;
        background: transparent;
      }
      .search-but {
        width: 30px;
        height: 30px;
      }
    }
    .top-right {
      display: flex;
      position: absolute;
      top: 35px;
      right: 11px;
      align-items: center;
      font-weight: 400;
      font-size: 9px;
      color: #666666;
      .right-img {
        width: 18px;
        height: 19px;
        margin-right: 5px;
      }
    }
  }
  .shop-center {
    // 推荐产品
    .product-list-title {
      margin: 12px 0 8px 18px;
      font-size: 14px;
      font-weight: Bold;
    }
    .product-list-summary {
      margin-left: 18px;
      font-size: 10.5px;
      font-weight: Regular;
    }
    .myhome-info-bottom {
      margin-top: 29px;
      .info-list-top {
        width: 356px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .list-style {
          width: 178px;
          height: 46.5px;
          line-height: 46.5px;
          text-align: center;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
          background: url("./img/bg1.png") no-repeat 100%;
          background-size: 100% 100%;
        }
        .list-check-style {
          color: #ffffff;
          background: url("./img/bg2.png") no-repeat 100%;
          background-size: 100% 100%;
        }
      }
      .info-list-bottom {
        width: 355px;
        margin: auto;
        .info-dataList {
          width: 335px;
          margin: 25px auto 0 auto;
          display: flex;
          //   justify-content: space-between;
          border-bottom: 0.5px solid #ededed;
          .li-style2 {
            width: 69px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            font-size: 11px;
            color: #666666;
            font-weight: 400;
            background: url("./img/bg3.png") no-repeat 100%;
            background-size: 100% 100%;
            &:not(:first-child) {
              margin-left: 5px;
            }
          }
          .li-check-style2 {
            font-weight: 500;
            color: #fc6e09;
          }
        }
        .bank-list {
          width: 355px;
          margin-top: 15.5px;
          padding: 10.5px 0 9.5px 0;
          background: #ffffff;
          border-radius: 10px;
          .list-com {
            width: 335px;
            margin: auto;
          }
          .bank-top,
          .bank-top-left {
            height: 65px;
            display: flex;
          }
          .bank-left-img {
            width: 128px;
            height: 65px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .bank-top {
            justify-content: space-between;
            align-items: center;
          }
          .bank-bottom {
            height: 56.5px;
            margin-top: 12px;
            padding: 3.5px 0;
            line-height: 1.58;
            overflow: hidden;
            background: #fffefb;
            p {
              height: 14px;
              padding-left: 17.5px;
              font-size: 10px;
            }
          }
        }
        .product-safe {
          height: 135px;
          padding: 0;
          align-items: center;
          display: flex;
          .product-safe-left {
            width: 128px;
            height: 110px;
            margin-left: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .product-safe-right {
            // border: 1px solid;
            width: 195.5px;
            height: 110px;
            margin-left: 11.5px;
            position: relative;
            .safe-right-but {
              position: absolute;
              bottom: 0;
              right: 0;
            }
            .safe-right-height {
              height: 45px;
              overflow: hidden;
            }
            .product-list-summary {
              margin-left: 0;
              height: 14px;
            }
            .product-list-title {
              margin: 10px 0 5px 6.5px;
            }
          }
        }
      }
      .hint-div{
        margin-top: 20px;
        text-align: center;
        font-size: 12px;
        color: #999;
      }
    }
    // 、、分享文章
    .home-data-list {
      width: 345px;
      margin: 16.5px auto 0 auto;
      .home-list-sty {
        width: 100%;
        height: 93.5px;
        display: flex;
        align-items: center;
        border-bottom: 0.5px solid #ededed;
        .list-left {
          width: 94.5px;
          height: 57px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .list-right {
          width: calc(345px - 110px);
          margin-left: 15.5px;
        }
        .list-top-right {
          width: 100%;
          margin: 0;
        }
        .list-r-tit {
          line-height: 12.5px;
          display: flex;
          align-items: flex-start;
          span {
            display: block;
            width: 197px;
            height: 27px;
            line-height: 1.2;
            overflow-y: hidden;
            margin-left: 8px;
            font-size: 10.5px;
            font-weight: Medium;
            font-family: PingFang SC;
            color: #333333;
          }
          .svg-icon {
            width: 27.5px;
            height: 17px;
          }
        }
        .list-r-foot {
          height: 12.5px;
          line-height: 0;
          display: flex;
          margin-top: 20px;
          span {
            height: 12.5px;
            display: flex;
            font-size: 9px;
            font-weight: Regular;
            font-family: PingFang SC;
            color: #999999;
          }
          .list-top-span {
            color: #ff2e2e;
            margin-right: 5px;
          }
        }
        .list-r-foot span:last-child {
          padding-left: 5px;
        }
      }
    }
  }
}
</style>